import brand from '@helpers/brand';
import { DateRangeCss } from '@helpers/dateRangeStyles';
import { fonts } from '@helpers/fonts';
import { ButtonStyles } from '@stories/Components/Buttons/Button/Button.styles';
import styled, { css } from 'styled-components';
const Wrapper = styled.div `
  max-width: 332px;
  display: flex;
  flex-direction: column;

  ${ButtonStyles.Button} {
    align-self: center;
  }

  ${DateRangeCss};

  ${({ hideCalendar }) => hideCalendar &&
    css `
      .rdrMonthAndYearWrapper,
      .rdrMonths {
        opacity: 0;
        height: 0;
        overflow: hidden;
        pointer-events: none;
      }
    `}
`;
const LabelText = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  ${fonts.DaxPro['Medium']};
  font-size: 18px;
  color: ${brand.grey.grey20};
  margin-bottom: 6px;
`;
export default {
    Wrapper,
    LabelText,
};
